<template>
    <div class="containerRepresentante">

         <div class="formulario">

           <div class="titleForm" style="display: inline-flex">
              <div style="width: 90%">

              <LabelDisclaimer :TamanhoFonteLabel="'H3'" :NomeLabel="'Representantes FATCA'" :TipoCliente="'Fundos'" :Sessao="'FATCA'" :SubSessao="'Representantes FATCA'"/>

              </div>
              <div  v-if="listaRepresentantes.length > 0" style="width: 10%; margin-top: 10px;">
              <button class="btnBlue" @click="incluirPessoa">+ Adicionar</button>
              </div>
           </div>
           <div class="resumoForm">
            <div class="opcoesForm" v-if="listaRepresentantes.length == 0">
                <img src="@/assets/addRepresentante.png" />
                <h3>Nenhum representante adicionado</h3>
                <h5>Você pode adicionar mais de um tipo e quantas representantes desejar</h5>
                <button class="btnBlue" @click="incluirPessoa">+ Adicionar</button>
            </div>
            <div v-if="listaRepresentantes.length > 0">
              <table class="table">
                <thead>
                  <th style="width: 20%">Nome</th>
                  <th style="width: 20%">CPF/CNPJ</th>
                  <th style="width: 20%">% Participação Societária</th>
                  <th style="width: 25%">Documento de identidade</th>
                  <th style="width: 20%">&nbsp;</th>
                </thead>
                <tbody>
                  <tr v-for="(representanteObj, index) in listaRepresentantes" :key="index">
                    <td>{{representanteObj.Nome}}</td>
                    <td>{{formatCpfCnpj(representanteObj.CpfCnpj)}}</td>
                    <td>{{representanteObj.Percentual}}%</td>
                    <td>{{representanteObj.Documento}}</td>
                    <td>
                      
                     <div class="widget icons" style="display: inline-flex">

                                        <a
                                            @click.stop.prevent="
                                                editarRepresentante(index)
                                            "
                                            class="ico__edit"
                                            title="editar"                                            
                                        >
                                            <Icon icon="ico-edit" />
                                            
                                        </a>
                                        <!-- v-if="politicaSelecionada == null || (politicaSelecionada != null && politicaSelecionada.guid == item.guid)" -->
                                     <a 
                                        @click.stop.prevent="deletarRepresentante(index)"
                                        class="ico__delete"
                                        title="deletar"    
                                        style="margin-left: 5px" 
                                    >
                                    </a>
                                     </div>


                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
           </div>

         </div>

           <ModalAddRepresentanteFatca />

    </div>

    
</template>


<script>

import { mapGetters } from 'vuex';
import ModalAddRepresentanteFatca from './ModalAddRepresentanteFatca.vue'
import formatCpfCnpj from '@/utils/formatCpfCnpj'
import LabelDisclaimer from '@/components/LabelDisclaimer.vue';
import api from '@/api/axios';

export default {
    name: 'RepresentanteFatca',
    props: ['Edicao'],
    mixins: [formatCpfCnpj],
    components: { ModalAddRepresentanteFatca, LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaRepresentantes: 'GET_LISTA_REPRESENTANTES_FI'
        }),
    },
    data() {
      return {

      };
    },
    created(){
       this.$store.dispatch('FETCH_FI_LISTA_REPRESENTANTES');
    },
    mounted(){
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA_FATCA', false);
    },
    methods: {
      proximaEtapa(){
        this.$store.commit('SET_ETAPA_CADASTRO', 2);
        this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
        this.salvarInformacoes();
      },
      salvarInformacoes(){
        this.$store.commit('SET_PF_SALVAR_INFO', true);
      },
      incluirPessoa(){
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA_FATCA', true);
      },
      editarRepresentante(index)
      {
        this.$store.commit('SET_MODAL_PJ_EDITAR_PESSOA', this.listaRepresentantes[index]);
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA_FATCA', true);
      },
      async deletarRepresentante(index){
             this.disableBtn = true;
              

                await  api.get(`fundo/facta/excluir?guid=${this.listaRepresentantes[index].Guid}`)
                    .then((retorno) => {
                          
                        if(retorno.status == 200)
                        {

                          this.$swal({
                              icon: 'success',
                              title: 'Exclusão realizada com sucesso!',
                              text: 'Dados informados foram excluídos com sucesso.',
                          });

                          this.$store.dispatch('FETCH_FI_LISTA_REPRESENTANTES');

                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });

        }

    }
}

</script>


<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

    .btnBlueUpload{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */
    widows: 88px;
      cursor: pointer;
    
  }


.formulario{
  margin-top: 20px;
  width: 100%;
  margin-bottom: 10px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */
  border: 1px solid #EAECF0;
  border-radius: 8px; /* Raio de borda */


.titleForm{
  background-color: white;
  border-bottom: 1px solid #EAECF0;
  width: 100%;

    .btnBlue{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */
    width: 100px;
    cursor: pointer;
    
  }

    h3{
      margin-left: 20px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

    h5{
    margin-top: 5px;
    margin-left: 20px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
  }


}

.resumoForm{
  width: 100%;

.opcoesForm{
    margin-left: 30%;
    display: grid;
    justify-content: space-between;
    align-content: space-between;
    align-items: center;
    justify-items: center;
    padding: 30px 0px 30px 0px;
    
  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
  }

    img{
      height: 48px;
      width: 48px;
      
    }


  .btnBlue{
    height: 40px;
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    background-color: #00235C;
    color: white;
    border: 1px solid #00235C; /* Borda */
    border-radius: 8px; /* Raio de borda */
    width: 350px;
    cursor: pointer;
    
  }
}

}

}

.agrupamentoFormulario{
  width: 100%;
  display: inline-flex;
  margin-top: 10px;
}

.categoriaAgrupamentoFormulario{
  width: 13%;
  margin-right: 15px;
  font-family: 'Inter', sans-serif; /* Fonte Inter */

  span{
    font-weight: 400 !important;
    font-size: 13px;
    color: #667085;
  }

}

.label__field{
  padding-right: 30px;
}

.camposAgrupamentoFormulario{
  width: 90%;

  .row{
    width: 100%;
    display: inline-flex;
    gap: 8px;
    margin-bottom: 10px;
  }

                  .accept {
                    display: inline-flex;

                    &:checked {
                      +label {
                            &:before {
                                background: white;
                                border: 1px solid black;
                                transition: background 0.3s;
                            }
                        }

                        +label {
                            &::after {
                                opacity: 1;
                                transition: all;
                                background: transparent;
                            }
                        }
                    }
                }

 .field {
    border-radius: 8px; /* Raio de borda */
    border: 1px solid #D0D5DD; /* Borda */
    padding: 10px 14px; /* Preenchimento interno */
    background-color: #F9FAFB; /* Cor de fundo */
    width: 100%;
    /* gap: 8px; - 'gap' não é aplicável diretamente ao input, mas pode ser usado em um container */
}

 .radio {
                display: flex;
                align-items: center;
                margin-right: 25px;

                @media (max-width: 768px) {
                    margin-right: 0;
                    margin-bottom: 20px;
                }

                .field__radio {
                    width: 20px;
                    height: 20px;
                }

                .fieldInRadio{
    border-radius: 8px; /* Raio de borda */
    border: 1px solid #D0D5DD; /* Borda */
    padding: 10px 14px; /* Preenchimento interno */
    background-color: #F9FAFB; /* Cor de fundo */
    width: 55%;
                }

                .label__radio {
                    margin-left: 5px;
                    margin-right: 40px;
                    margin-top: 5px;
                }
            }

select{
  width: 105% !important;
}


label {
    font-family: 'Inter', sans-serif; /* Fonte Inter */
    font-weight: 500; /* Peso médio */
    font-size: 14px; /* Tamanho da fonte */
    line-height: 20px; /* Altura da linha */
    color: #344054; /* Cor */
    display: block; /* Garante que a label fique acima do input */
    margin-bottom: 8px; /* Espaçamento entre a label e o input abaixo dela */
}

}





.title{

  border-bottom: 1px solid #EAECF0;

  h3{
    margin-top: 50px;
    color: #101828;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    
  }

  h5{
    margin-top: 5px;
    margin-block-start: 0;
    color: #667085;
    font-weight: 400;
    font-family: 'Inter', sans-serif;
  }
}


</style>